import * as types from '../constants/prospectConstants.js';

const initialState = {
  prospects: [],
  loading: false,
  error: null,
  success: false
};

export const prospectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_PROSPECT_REQUEST:
    case types.GET_PROSPECTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };

    case types.CREATE_PROSPECT_SUCCESS:
      return {
        ...state,
        loading: false,
        prospects: [...state.prospects, action.payload],
        success: true,
        error: null
      };

    case types.GET_PROSPECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        prospects: action.payload,
        error: null
      };

    case types.CREATE_PROSPECT_FAILURE:
    case types.GET_PROSPECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case types.CLEAR_PROSPECT_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};